module.exports = __webpack_public_path__ + "img/jetrodder_driving.99270067.svg";